import { render, staticRenderFns } from "./ModalRegisterPayment.vue?vue&type=template&id=37459a77&scoped=true"
import script from "./ModalRegisterPayment.vue?vue&type=script&lang=js"
export * from "./ModalRegisterPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37459a77",
  null
  
)

export default component.exports